import { TaskExpenseDynamicsKindEnum } from '@zaoblako/shared/modules/task/enum/task.expense.dynamics.kind.enum';
import { TaskState } from '@zaoblako/web/modules/payments/components/task/card/models/task-state';

export const taskInitialState: TaskState = {
  loading: false,
  task: null,
  brsSettings: null,
  panelsInfo: {
    actionsShow: true,
    ordersShow: true,
    analyticsShow: true,
    expenseDynamicsShow: true,
    paymentDetailsShow: true
  },
  expenseDynamicsPanel: {
    loading: true,
    queryParams: {
      kind: TaskExpenseDynamicsKindEnum.DIRECTION
    },
    items: []
  },
  filesInfo: {
    files: [],
    loading: false
  },
  directions: [],
  nds: [],
  organizations: [],
  priorities: [],
  userGroups: []
};
